<template>
  <v-container class="schedules-widget">
    <v-subheader>
      {{ lang.scheduler.new.widget.title }}
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" class="info-tip">
            <v-icon small>mdi-information-variant</v-icon>
          </v-btn>
        </template>
        <span
          v-html="lang.scheduler.new.widget.infotip"
          style="text-align: center;"
        />
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="clearForm()"
            class="mr-2 clear-btn"
            color="gray darken-2"
          >
            <v-icon small>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.historic.filters.clear }}</span>
      </v-tooltip>
    </v-subheader>
    <v-form
      ref="SubSearchForm"
      :disabled="get_interface.loading || loading"
      class="filters-form"
    >
      <v-row class="filters-row">
        <v-col cols="10">
          <Employees
            v-model="filters.employees"
            :services_in="services_in"
            :loading="get_interface.loading || loading"
            returnObject
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="filters.limit"
            :label="lang.scheduler.new.limit"
            :rules="lang.scheduler.new.rules.limit"
            :loading="get_interface.loading || loading"
            :disabled="get_interface.loading || loading"
            type="number"
            autocomplete="new-password"
            filled
          />
        </v-col>
      </v-row>
      <v-row class="filters-row">
        <v-col cols="6" lg="4" md="4" sm="6" class="filters-col">
          <div class="checkbox-container">
            <v-checkbox
              v-model="filters.match"
              :disabled="(get_interface.loading || loading) || (filters.employees || []).length <= 0"
              color="primary"
              class="small-checkbox ma-0"
              hide-details
            >
              <template v-slot:label>
                <span>{{ lang.scheduler.new.widget.filters.match.title }}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" class="info-tip">
                      <v-icon small>mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span
                    v-html="lang.scheduler.new.widget.filters.match.infotip"
                    style="text-align: center;"
                  />
                </v-tooltip>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="filters.office_hour"
              :disabled="get_interface.loading || loading"
              color="primary"
              class="small-checkbox ma-0"
              hide-details
            >
              <template v-slot:label>
                <span>{{ lang.scheduler.new.widget.filters.office_hour.title }}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" class="info-tip">
                      <v-icon small>mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span
                    v-html="lang.scheduler.new.widget.filters.office_hour.infotip"
                    style="text-align: center;"
                  />
                </v-tooltip>
              </template>
            </v-checkbox>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="2" sm="6" class="filters-col">
          <v-text-field
            v-model="filters.duration"
            :label="lang.scheduler.new.duration"
            :rules="lang.scheduler.new.rules.duration"
            :loading="get_interface.loading || loading"
            :disabled="get_interface.loading || loading"
            type="number"
            autocomplete="new-password"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="6" lg="3" md="3" sm="6" class="filters-col">
          <v-menu
            v-model="menu.date"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="formatDate(filters.date, false)"
                :label="lang.scheduler.new.widget.filters.date"
                :loading="get_interface.loading || loading"
                :disabled="get_interface.loading || loading"
                prepend-inner-icon="mdi-calendar"
                clearable
                readonly
                filled
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.date"
              @input="date_menu = false"
              locale="pt-BR"
              :min="today"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" lg="3" md="3" sm="6" class="filters-col">
          <v-menu
            ref="menu"
            v-model="menu.time"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters.time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                v-model="filters.time"
                :label="lang.scheduler.new.widget.filters.time"
                :loading="get_interface.loading || loading"
                :disabled="get_interface.loading || loading"
                prepend-inner-icon="mdi-clock-time-four-outline"
                readonly
                filled
                clearable
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="menu.time"
              v-model="filters.time"
              :allowed-minutes="allowedStep"
              format="24hr"
              full-width
              @click:minute="$refs.menu.save(filters.time)"
            ></v-time-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
    <v-row class="selector-row">
      <Selector
        v-model="selected"
        :filters="filters"
        :loader="loading"
        :services_in="services_in"
        :others="others"
        :errors="errors"
        :edit="edit"
        :UUID="(edit ? edit_value.UUID : '')"
        @loader="(new_) => loading = new_"
        @dayPaginator="dayPaginator"
      />
    </v-row>
  </v-container>
</template>

<script>
import Employees from './templates/autocomplete/Employees'
import Selector from './templates/widget/Selector'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import { format, addDays, subDays } from 'date-fns'

export default {
  components: { Employees, Selector },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit_value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    items: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    others: {
      type: Array,
      default: () => {
        return []
      }
    },
    errors: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      today: this.getDate_(false),
      loading: true,
      filters: {
        employees: [],
        limit: 2,
        duration: 30,
        match: false,
        office_hour: true,
        date: this.edit_value.date || '',
        time: ''
      },
      menu: {
        date: false,
        time: false
      },
      selected: []
    }
  },
  computed: {
    services_in () {
      let services = this.services || [],
          list = this.items || []
      return services.filter(serv => list.indexOf(serv.UUID) >= 0) || []
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
          this.$emit('input', [ ...newVal ])
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.selected)) {
          this.selected = [ ...newVal ]
        }
      }
    }
  },
  methods: {
    allowedStep: m => m % 30 === 0,
    dayPaginator (action) {
      var [ year, month, day ] = [ ...this.filters.date.split("-") ]
      month = month - 1
      let curr = new Date(year, month, day),
          new_ = (action > 0 ? addDays(curr, 1) : subDays(curr, 1))
      this.filters.date = format(new_, 'yyyy-MM-dd')
    },
    clearForm () {
      if (this.$refs.SubSearchForm) this.$refs.SubSearchForm.reset()
    }
  }
}
</script>

<style src="./styles/widget.scss" lang="scss"></style>
